module.exports = __webpack_public_path__ + "static/img/1049.41d28d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1049.jpg
// module id = 231
// module chunks = 0